import {
  GAZA_DEPARTMENT,
  QUDUS_DEPARTMENT,
  LOD_DEPARTMENT,
  HAIFA_DEPARTMENT,
  GALILEE_DEPARTMENT,
  SAMARIA_DEPARTMENT,
} from '../constants/departments';

import {  GAZA,
  B2R_SAB3,

  HAIFA,

  YAFA,
  RAMLA,
  
  GANIN,
  NABLUS,
  TULKARM,

  SAFED,
  AKKA,
  NAZARETH,
  BEISAN,
  TIBERIAS,

  QUDUS,
  RAMALLAH,
  HEBRON} from '../constants/states'

const translation = {
  [GAZA_DEPARTMENT]: { en: 'GAZA DEPARTMENT', ar: 'مقاطعة غزة' },
  [QUDUS_DEPARTMENT]: { en: 'QUDUS DEPARTMENT', ar: 'مقاطعة القدس' },
  [LOD_DEPARTMENT]: { en: 'LOD DEPARTMENT', ar: 'مقاطعة اللد' },
  [HAIFA_DEPARTMENT]: { en: 'HAIFA DEPARTMENT', ar: 'مقاطعة حيفا' },
  [GALILEE_DEPARTMENT]: { en: 'GALILEE DEPARTMENT', ar: ' مقاطعة الخليل ' },
  [SAMARIA_DEPARTMENT]: { en: 'SAMARIA DEPARTMENT', ar: 'مقاطعة السامرية' },
  [GAZA]:{en:'GAZA', ar:'غزة'},
  [B2R_SAB3]:{en:'B2R_SAB3', ar:'بئر السبع'},

  [HAIFA]:{en:'HAIFA', ar:'حيفا'},

  [YAFA]:{en:'YAFA', ar:'يافا'},
  [RAMLA]:{en:'RAMLA', ar:' الرملة'},
  
  [GANIN]:{en:'GANIN', ar:'الخليل'},
  [NABLUS]:{en:'NABLUS', ar:'نابلس'},
  [TULKARM]:{en:'TULKARM', ar:'طولكرم'},

  [SAFED]:{en:'SAFED', ar:'صفد'},
  [AKKA]:{en:'AKKA', ar:' عكا'},
  [NAZARETH]:{en:'NAZARETH', ar:'الناصرة'},
  [BEISAN]:{en:'BEISAN', ar:' بيسان'},
  [TIBERIAS]:{en:'TIBERIAS', ar:'طبريا'},

  [QUDUS]:{en:'QUDUS', ar:'القدس'},
  [RAMALLAH]:{en:'RAMALLAH', ar:' رام الله'},
  [HEBRON]:{en:'HEBRON', ar:'الخليل'},
};

export default translation;
